import * as React from "react";
import { Button } from "./button";

interface InfoPanelProps {
    visible: boolean;
    onCloseButtonClicked: () => void;
}

export class InfoPanel extends React.Component<InfoPanelProps, {}> {
    render(): JSX.Element {
        let visible = this.props.visible;
        return <div className={"fullscreen hbox" + (visible ? " clickable" : "")}>
            <div className={"info-panel" + (visible ? "-visible" : "")}>
                { this.renderText() }
                <div style={{ position: "absolute", top: 14, right: 14 }}>
                    <Button className="info-close-button"
                            normalImgSrc="assets/app/images/button-close.png"
                            onClicked={this.props.onCloseButtonClicked}/>
                </div>
            </div>
            <div className="expand" onClick={this.props.onCloseButtonClicked}/>
        </div>;
    }

    //  Hashtags are also mentionned here
    private renderText(): JSX.Element {
        return <div className="info-text">
            <p>This Social Media Worldmap Dashboard is collecting and comparing all web &amp; social publications of the past 30 days about  the 4 topics :  #PyeongChang2018  #TorchRelay,  IOC &amp; Technology,  #AtosTeam.</p>
            <p>With this 3D world map data visualization you’ll be able to manipulate the map from a touch screen and rotate the globe easily. You can also zoom at country level and compare the topics key figures by selecting the use case icons on the right. You can deselect a topic by simply clicking again on the icon.</p>
            <p>Glossary of key use cases proposed in this geo-localized data visualization:</p>
            <div className="vbox">
            <div className="hbox" style={{margin: "5px 0px"}}><img className="info-metric-icon" src="assets/app/images/button-Engagement_highlight.png"/><div><b>Engagement:</b>&#x2005;The engagement value is the sum of all actions (share, like, retweet, comments) made by Internet users on a publication article or post.</div></div>
            <div className="hbox" style={{margin: "5px 0px"}}><img className="info-metric-icon" src="assets/app/images/button-Publications_highlight.png"/><div><b>Publications:</b>&#x2005;The publications value is the total of articles, posts, publications on social media mentioning the brand selected.</div></div>
            <div className="hbox" style={{margin: "5px 0px"}}><img className="info-metric-icon" src="assets/app/images/button-Media_highlight.png"/><div><b>Media:</b>&#x2005;This media feature will display the media volume of publications from Instagram, Facebook, Twitter and YouTube per countries - one topic at a time.</div></div>
            <div className="hbox" style={{margin: "5px 0px"}}><img className="info-metric-icon" src="assets/app/images/button-Sentiment_highlight.png"/><div><b>Sentiment:</b>&#x2005;This feature measures the share of topic tonality per country. The sentiment analysis helps to compare locations and track Positive, Neutral &amp; Negative publications - one topic at a time.</div></div>
            </div>
            <p>This Social Media Tool is powered by <img src="assets/app/images/Atos-Logo-White.png" height="10" width="auto"/></p>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/infoPanel.tsx